let introPlayed = false;

class SealYogGiftIcon extends HTMLElement {
  #observer;
  #trigger;
  #animations = [];
  #motion = window.matchMedia('(prefers-reduced-motion: reduce)');

  connectedCallback() {
    this.#trigger = this.closest('button');
    this.#trigger?.addEventListener('pointerenter', this.#onPointerEnter);
    this.#trigger?.addEventListener('focusin', this.#play);
    this.#motion.addEventListener('change', this.#onMotionChange);

    if (!introPlayed && !this.#motion.matches) {
      this.#observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.#observer.disconnect();
        if (introPlayed) return;
        introPlayed = true;
        this.#play();
      }, { threshold: 1 });
      this.#observer.observe(this);
    }
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#trigger?.removeEventListener('pointerenter', this.#onPointerEnter);
    this.#trigger?.removeEventListener('focusin', this.#play);
    this.#motion.removeEventListener('change', this.#onMotionChange);
    this.#cancel();
  }

  #onPointerEnter = (event) => {
    if (event.pointerType === 'mouse') this.#play();
  };

  #onMotionChange = () => {
    if (this.#motion.matches) this.#cancel();
  };

  #cancel() {
    this.#animations.forEach((animation) => animation.cancel());
    this.#animations = [];
  }

  #play = () => {
    if (this.#motion.matches || document.hidden || !this.isConnected) return;
    if (this.#animations.some((animation) => animation.playState === 'running')) return;
    const lid = this.querySelector('[data-gift-lid]');
    const box = this.querySelector('[data-gift-box]');
    if (!lid || !box) return;
    this.#cancel();

    const ease = 'cubic-bezier(0.22, 1, 0.36, 1)';
    const timing = { duration: 1600, easing: 'linear' };
    this.#animations = [
      lid.animate([
        { transform: 'translateY(0) rotate(0deg)', offset: 0, easing: ease },
        { transform: 'translateY(0.6px) rotate(0deg)', offset: 0.12, easing: ease },
        { transform: 'translate(-0.6px, -4px) rotate(-9deg)', offset: 0.42 },
        { transform: 'translate(-0.6px, -4px) rotate(-9deg)', offset: 0.58, easing: 'cubic-bezier(0.45, 0, 0.55, 1)' },
        { transform: 'translateY(0.35px) rotate(0deg)', offset: 0.87, easing: ease },
        { transform: 'translateY(0) rotate(0deg)', offset: 1 },
      ], timing),
      box.animate([
        { transform: 'scaleY(1)', offset: 0, easing: ease },
        { transform: 'scaleY(0.97)', offset: 0.12, easing: ease },
        { transform: 'scaleY(1)', offset: 0.42 },
        { transform: 'scaleY(1)', offset: 0.78, easing: ease },
        { transform: 'scaleY(0.985)', offset: 0.89, easing: ease },
        { transform: 'scaleY(1)', offset: 1 },
      ], timing),
    ];
  };
}

if (!customElements.get('seal-yog-gift-icon')) {
  customElements.define('seal-yog-gift-icon', SealYogGiftIcon);
}
